import {UserType} from './enums/user-type.enum';
import _ from 'lodash';

export function removeUsersCombinedAttributes(user): void {
    if (Array.isArray(user.dicAttributes)) {
        user.dicAttributes = user.dicAttributes.filter((attr) => {
            return !attr.isCombined;
        });
    }
}

export function removeUsersNonLocalAttributes(user): void {
    if (Array.isArray(user.dicAttributes)) {
        user.dicAttributes = user.dicAttributes.filter((attr) => {
            return attr.local;
        });
    }
}

export function restructureFilterParams(parameters: any): void {
    if (parameters) {
      if (parameters.filter && parameters.filter.origin) {
        const value = parameters.filter.origin.value;
        if (value.type === UserType.LOCAL) {
          parameters.filter.isLocal = {
            operator: parameters.filter.origin.operator,
            value: true
          };
        } else if (value.type === UserType.LDAP_SERVER) {
          parameters.filter.ldapServer = {
            operator: parameters.filter.origin.operator,
            value: value.value
          };
        } else if (value.type === UserType.FILE_REPOSITORY) {
          parameters.filter.fileRepository = {
            operator: parameters.filter.origin.operator,
            value: value.value
          };
        }
        delete parameters.filter.origin;
      } else if (parameters.userGroup) {
        parameters.filter = {};
        parameters.filter.userGroup = {
          operator: '=',
          value: parameters.userGroup
        };
      }
    }
}

export function addDictionaryAttributesAsProperties(user): void {
    user.dicAttributes.forEach((attr) => {
        const attrName = 'dicAttr_' + attr.dicAttrId;
        if (!_.isNil(user[attrName])){
          user[attrName] = [user[attrName], attr.value];
        }else{
          user[attrName] = attr.value;
        }
    });
}
